import { render } from "./UploadFileModal.vue?vue&type=template&id=336f8885&scoped=true"
import script from "./UploadFileModal.vue?vue&type=script&lang=js"
export * from "./UploadFileModal.vue?vue&type=script&lang=js"

import "./UploadFileModal.vue?vue&type=style&index=0&id=336f8885&scoped=true&lang=css"

import exportComponent from "/Users/mac/MyDev/3-READY/v2t/vid2text/youtest.ru/youtest-front-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-336f8885"]])

export default __exports__